/* eslint-disable react-hooks/exhaustive-deps */
import { useSelector } from "react-redux";
import { Button } from "semantic-ui-react";
import axios from 'axios';
import { selectCurrentUserApiToken, selectCurrentUserId, selectCurrentUserNotificationEmail } from "../slices/currentUser/currentUserSlice";
import { selectResourceById } from "../slices/resourceCollection/resourceCollectionSlice";
import Spinner from "../components/Spinner";
import CompositionPdfViewer from "./compositionResourceComponents/CompositionPdfViewer";
import CompositionCoreDisplay from "./compositionResourceComponents/CompositionCoreDisplay";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const CompositionDisplay = ({ foi }) => {
    const apiToken = useSelector(selectCurrentUserApiToken);
    const notificationEmail = useSelector(selectCurrentUserNotificationEmail);
    const userId = useSelector(selectCurrentUserId);
    const isLoggedIn = (!!userId && userId !== "1");
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    const resourceJson = parentResourceDetail?.revisedResourceJson;

    if (!resourceJson) {
        return <Spinner />;
    }

    return <div>
        <div id="top" ></div>
        <h1>{resourceJson.title ? resourceJson.title : "Edit metadata to add title"}</h1>
        {(foi === "111563" || foi === "27845") && <><Button className="formButton" positive
            content="Join Voting Group"
            onClick={async () => {
                let codeSystemFoi;
                if (foi === "111563") {
                    codeSystemFoi = "27833";
                } else if (foi === "27845") {
                    codeSystemFoi = "27270";
                }
                if (isLoggedIn) {
                    let resp = await axios({
                        method: 'POST',
                        //url: server_address + ':' + ports["master_server"] + '/',
                        url: fevir_node_server_address,
                        timeout: 8000,
                        data: {
                            'functionid': "joinvotingpermissiongroup",
                            'aboutformstateid': codeSystemFoi,
                            'apiToken': apiToken
                        },
                    });
                    if (resp?.data?.success) {
                        let emailMessage = "We don't have a notification email on file for you. Please visit your user profile by clicking your name in the upper right corner and add one. Otherwise, you won't receive a notification when terms are ready for vote.";
                        if (notificationEmail) {
                            emailMessage = `Your email on record is: ${notificationEmail} which we will use to send you notices when terms are ready for vote. If you want to change your email address used for notification, please edit your user profile by clicking your name in the upper right corner.`;
                        }
                        alert(`Welcome to the ${resp?.data?.groupname}! ${emailMessage}`);
                    } else {
                        if (resp?.data?.error) {
                            alert(resp.data.error);
                        } else {
                            alert("Joining the group was unsuccessful.");
                        }
                    }
                } else {
                    alert("Please log in to join the group.");
                }
            }}
        /><br /><br /></>}
        <CompositionPdfViewer fhirJson={resourceJson} />
        <CompositionCoreDisplay foi={foi} />
    </div>
}

export default CompositionDisplay;